import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match?.[1];
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                // Clear hash so re-renders don't retrigger
                window.history.replaceState(null, "", window.location.pathname);
                setUser(data.user);
                if (data.user.role === "unassigned") {
                    navigate("/login", { replace: true, state: { user: data.user } });
                } else if (data.user.role === "coach") {
                    navigate("/dashboard", { replace: true, state: { user: data.user } });
                } else {
                    navigate("/", { replace: true, state: { user: data.user } });
                }
            } catch (e) {
                console.error(e);
                navigate("/login", { replace: true });
            }
        })();
    }, [location, navigate, setUser]);

    return (
        <div className="flex min-h-[70vh] items-center justify-center">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-neutral-500">
                Connexion en cours...
            </div>
        </div>
    );
}
